<template>
    <b-row :class="{selected}" class="menu-row">
        <a href="#" ref="icon">
            <Icon :icon="icon" size="2x" class="p-1" id="t1"></Icon>
        </a>
        <b-tooltip :target="() => $refs['icon']" placement="right" boundary="window">
            {{label}}
        </b-tooltip>
        <a class="pt-1 typo-link">
            <span>{{label}}</span>
        </a>
    </b-row>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        default: "None"
      },
      icon: {
        type: String,
        default: "question-circle"
      },
      selected: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "../../assets/style/base/colors";

    div {
        .menu-row {
            height: 35px;
            overflow: hidden
        }
        .selected {
            background-color: $sgp-light-blue;
            & a {
                color: $white;
            }
        }
        &:hover {
            background-color: $grey;
            & > a {
                color: $white;
            }
        }
    }

    a {
        padding-left: 4px;
        font-size: 16px;
        color: $grey;
    }

</style>